<template>
  <div class="check-submit">
    <img
      v-show="type == '1'"
      src="../../assets/register/icon-bxg-qrcode.png"
      alt=""
    />
    <img
      v-show="type == '2'"
      src="../../assets/register/icon-bxg-computer.png"
      alt=""
    />
    <div v-show="type == '1'" class="tips">切换微信扫码{{ txt }}</div>
      <div v-show="type == '2' && txt=='登录'" class="tips tips-width2">切换账号登录</div>
    <div v-show="type == '2' && txt!='登录'" class="tips tips-width">切换手机号{{ txt }}</div>
  
  </div>
</template>

<script>
export default {
  props: ["type", "txt"],
  data() {
    return {};
  },
  methods: {
    changeType() {
      this.$emit("setRegisterType", this.type);
      this.$emit("setLoginType", this.type);

   
    },
  },
};
</script>

<style lang="scss" scoped>
.check-submit {
  position: absolute;
  border-radius: 6px 6px 6px 0;
  width: 64px;
  height: 64px;
  background: rgba(22, 93, 255, 0.12);
  right: 2px;
  top: 2px;
  z-index: 1;
  &:hover {
    background-color: rgba(22, 93, 255, 0.24);
  }
  &:hover .tips {
    display: block;
  }
  img {
    margin: 4px 0 0 12px;
    width: 48px;
    height: 48px;
  }
  &::before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    top: 0;
    border-bottom: 64px solid #ffffff;
    border-right: 64px solid transparent;
    z-index: 20;
  }
  .tips-width {
    width: 101px !important;
    left: -92px !important;
  }
  .tips-width2{
    width: 90px !important;
    left: -82px !important;
  
  }
  .tips {
    width: 113px;
    height: 32px;
    background: #165dff;
    box-shadow: 0px 3px 14px 2px rgba(0, 0, 0, 0.05),
      0px 8px 10px 1px rgba(0, 0, 0, 0.06), 0px 5px 5px -3px rgba(0, 0, 0, 0.1);
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    position: absolute;
    z-index: 99;
    top: 16px;
    left: -105px;
    line-height: 32px;
    padding-left: 8px;
    box-sizing: border-box;
    border-radius: 4px;
    display: none;
    &::after {
      content: "";
      display: block;
      position: absolute;
      right: -4px;
      top: 0;
      bottom: 0;

      margin: auto;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
      width: 8px;
      height: 8px;
      background: #165dff;
    }
  }
}
</style>
